import { render } from "./ProjectType.vue?vue&type=template&id=233defbc"
import script from "./ProjectType.vue?vue&type=script&lang=js"
export * from "./ProjectType.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__